export const BadgeList = [
    {id: '0', name: "Season One", description: "He was on Season One. A true legend."},
    {id: '1', name: "Hawkeye", description: "Wow! Are you REALY reads incoming mail?"},
    {id: '2', name: "Explorer", description: "Take 20,000 steps."},
    {id: '3', name: "Dragonborn", description: "Slay ender dragon 10 times."},
    {id: '4', name: "Fighter", description: "Win a PvP fight."}
];